import { createSlotRecipe } from './runtime.js';

const chatApprovalCardConfig = {"name":"chatApprovalCard","slots":["root","header","icon","headings","title","description","detail","actions","buttons","status"],"defaultVariants":{"state":"request"},"variantMap":{"state":["approved","cancelled","denied","expired","request","running"]}}

export const chatApprovalCard = /* @__PURE__ */ createSlotRecipe(chatApprovalCardConfig)